define.alias("shared/services/shared/popup-manager", "auth/services/shared/popup-manager");